import React, { useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import clsx from "clsx";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { handleDrawerToggle } from "../../redux/actions/theme-action";
import {
  adminPathLocations,
  pathLocations,
  PlayerPathLocations,
} from "../../utils/pathLocations";
import { NavLink } from "react-router-dom";
import { Collapse, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ExpandMore } from "@mui/icons-material";

const menuStyles = makeStyles({
  appLogo: {
    width: "100px",
  },
  userIcon: {
    margin: 10,
    cursor: "pointer",
  },
  bellIcon: {
    margin: 10,
    cursor: "pointer",
  },
  headerUserIcon: {
    color: "#2C633C !important",
    padding: "4px  !important",
    "&:hover": {},
  },
  breadcrumbsBox: {
    padding: 17,
    paddingBottom: 1,
    "& a:hover": {
      color: "black",
    },
  },

  menuItemText: {
    color: "black",
    fontSize: "14px !important",
    marginLeft: "10px !important",
    fontWeight: "500 !important",
  },
  activeMenuItem: {
    background: "#06623B !important",
    padding: "0px 15px  !important",
    marginLeft: "-14px  !important",
    marginRight: "-14px  !important",
    borderRight: "1px solid green  !important",
    borderRadius: "11px  !important",
    color: "white",
    "&  span": {
      color: "white",
    },
  },
  userNameHeading: {
    color: "#06623B",
    fontWeight: "900px",
  },
  popoverColor: {
    color: "#06623B",
  },
  popoverBtn1: {
    backgroundColor: "#2C633C !important",
  },
  popoverBtn2: {
    backgroundColor: "#FF0000 !important",
  },
  popoverNotificationIcon: {
    color: "#2C633C",
    fontSize: "34px !important",
    alignSelf: "center !important",
  },
  MenuListItem: {
    flexDirection: "column",
    "&:hover": {
      padding: "0px 15px  !important",
      borderRadius: "11px  !important",
    },
  },

  menuSubNavItemText: {
    width: "fit-content",
    maxWidth: "fit-content",
    paddingRight: "0",
    "& span": {
      width: "fit-content",
    },
  },

  MenuListItemButton: {
    width: "100%",
    borderRadius: "11px",
    marginBottom: "10px",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    padding: "10px 15px",
    cursor: "pointer",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.04)",
    },
  },
  MenuListItemButtonActive: {
    width: "100%",
    borderRadius: "10px",
    marginBottom: "10px",
    textDecoration: "none",
    display: "flex",
    background: "#06623B",
    padding: "10px 15px",
    alignItems: "center",
    "&:hover": {
      borderRadius: "11px  !important",
    },
    "& > p": {
      color: "white",
      fontWeight: "700 !important",
    },
  },

  SubMenuListItemButton: {
    width: "80%",
    borderRadius: "11px",
    marginBottom: "10px",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    padding: "10px 15px",
    cursor: "pointer",
    margin: "0px auto",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.04)",
    },
  },

  SubMenuListItemButtonActive: {
    width: "80%",
    borderRadius: "11px",
    marginBottom: "10px",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    background: "#06623B",
    padding: "10px 15px",
    cursor: "pointer",
    margin: "0px auto",
    "& > p": {
      color: "white",
      fontWeight: "700 !important",
    },
  },

  MenuSubNavListItemButton: {
    width: "159px",
  },
  MenuItemImage: {
    height: 24,
    width: 24,
  },
  MenuItemIcon: {
    backgroundColor: "red",
    width: 24,
    zIndex: 1,
    minWidth: "24px !important",
  },
  MenuSubNavActive: {
    marginLeft: "5%",
  },
});

function SubNavLinks(props) {
  const { openSubNav, children, toggleDrawer } = props;
  const classes = menuStyles();
  const dispatch = useDispatch();

  return (
    <Collapse
      in={openSubNav}
      unmountOnExit
      className={clsx({
        [classes.MenuSubNavActive]: openSubNav,
      })}
    >
      <List component="div" disablePadding>
        {children.map((item, index) => (
          <NavLink
            className={({ isActive }) =>
              isActive
                ? classes.SubMenuListItemButtonActive
                : classes.SubMenuListItemButton
            }
            to={item?.link}
            key={index}
            onClick={() => dispatch(handleDrawerToggle(false))}
          >
            <img
              src={item.icon}
              alt={item.title}
              className={classes.MenuItemImage}
            />
            <Typography className={classes.menuItemText}>
              {item.title}
            </Typography>
          </NavLink>
        ))}
      </List>
    </Collapse>
  );
}

const DrawerMenu = () => {
  // Selector
  const { drawer } = useSelector((state) => state.themeReducer);
  const role = useSelector((state) => state?.userDetailsReducer?.role);

  const dispatch = useDispatch();
  const classes = menuStyles();

  const [openSubNavItem, setopenSubNavItem] = React.useState("");

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    console.log(open);

    dispatch(handleDrawerToggle(open));
  };

  const handleNavMenuOnClick = (name) => {
    if (openSubNavItem === name) setopenSubNavItem("");
    else setopenSubNavItem(name);
  };

  const list = () => (
    <Box
      sx={{ width: 300, zIndex: 9, paddingX: "20px", paddingY: "40px" }}
      role="presentation"
    >
      <List>
        {role === "super" ? (
          <>
            {pathLocations.map((item, index) => {
              if (item.icon && item.isEnabled)
                return (
                  <>
                    {item?.children?.length > 0 ? (
                      <>
                        <ListItem
                          key={index}
                          className={classes.MenuListItemButton}
                          sx={{ justifyContent: "space-between" }}
                          onClick={() => handleNavMenuOnClick(item.title)}
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <img
                              src={item.icon}
                              alt={item.title}
                              className={classes.MenuItemImage}
                            />
                            <Typography className={classes.menuItemText}>
                              {item.title}
                            </Typography>
                          </Box>
                          <ExpandMore />
                        </ListItem>
                        {item.children?.length > 0 && (
                          <SubNavLinks
                            toggleDrawer={toggleDrawer}
                            children={item.children}
                            openSubNav={openSubNavItem === item.title}
                          />
                        )}
                      </>
                    ) : (
                      <NavLink
                        className={({ isActive }) =>
                          isActive
                            ? classes.MenuListItemButtonActive
                            : classes.MenuListItemButton
                        }
                        to={item?.link}
                        key={index}
                        onClick={() => dispatch(handleDrawerToggle(false))}
                      >
                        <img
                          src={item.icon}
                          alt={item.title}
                          className={classes.MenuItemImage}
                        />
                        <Typography className={classes.menuItemText}>
                          {item.title}
                        </Typography>
                      </NavLink>
                    )}
                  </>
                );
            })}
          </>
        ) : role === "admin" ? (
          <>
            {adminPathLocations.map((item, index) => {
              if (item.icon && item.isEnabled)
                return (
                  <>
                    {item?.children?.length > 0 ? (
                      <>
                        <ListItem
                          key={index}
                          className={classes.MenuListItemButton}
                          sx={{ justifyContent: "space-between" }}
                          onClick={() => handleNavMenuOnClick(item.title)}
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <img
                              src={item.icon}
                              alt={item.title}
                              className={classes.MenuItemImage}
                            />
                            <Typography className={classes.menuItemText}>
                              {item.title}
                            </Typography>
                          </Box>
                          <ExpandMore />
                        </ListItem>
                        {item.children?.length > 0 && (
                          <SubNavLinks
                            toggleDrawer={toggleDrawer}
                            children={item.children}
                            openSubNav={openSubNavItem === item.title}
                          />
                        )}
                      </>
                    ) : (
                      <NavLink
                        className={({ isActive }) =>
                          isActive
                            ? classes.MenuListItemButtonActive
                            : classes.MenuListItemButton
                        }
                        to={item?.link}
                        key={index}
                        onClick={() => dispatch(handleDrawerToggle(false))}
                      >
                        <img
                          src={item.icon}
                          alt={item.title}
                          className={classes.MenuItemImage}
                        />
                        <Typography className={classes.menuItemText}>
                          {item.title}
                        </Typography>
                      </NavLink>
                    )}
                  </>
                );
            })}
          </>
        ) : (
          <>
            {PlayerPathLocations.map((item, index) => {
              if (item.icon && item.isEnabled)
                return (
                  <>
                    {item?.children?.length > 0 ? (
                      <>
                        <ListItem
                          key={index}
                          className={classes.MenuListItemButton}
                          sx={{ justifyContent: "space-between" }}
                          onClick={() => handleNavMenuOnClick(item.title)}
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <img
                              src={item.icon}
                              alt={item.title}
                              className={classes.MenuItemImage}
                            />
                            <Typography className={classes.menuItemText}>
                              {item.title}
                            </Typography>
                          </Box>
                          <ExpandMore />
                        </ListItem>
                        {item.children?.length > 0 && (
                          <SubNavLinks
                            children={item.children}
                            toggleDrawer={toggleDrawer}
                            openSubNav={openSubNavItem === item.title}
                          />
                        )}
                      </>
                    ) : (
                      <NavLink
                        className={({ isActive }) =>
                          isActive
                            ? classes.MenuListItemButtonActive
                            : classes.MenuListItemButton
                        }
                        to={item?.link}
                        key={index}
                        onClick={() => dispatch(handleDrawerToggle(false))}
                      >
                        <img
                          src={item.icon}
                          alt={item.title}
                          className={classes.MenuItemImage}
                        />
                        <Typography className={classes.menuItemText}>
                          {item.title}
                        </Typography>
                      </NavLink>
                    )}
                  </>
                );
            })}
          </>
        )}
      </List>
    </Box>
  );

  return (
    <div>
      <Drawer anchor="right" open={drawer} onClose={toggleDrawer(false)}>
        {list()}
      </Drawer>
    </div>
  );
};

export default DrawerMenu;
